import { CustomText } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { moneyFormat } from '@4beefopag/4bee-fopag-core/dist/util';
import React from 'react';
import { OPERATION_LOG } from '../../../services/util/globalConstant';
import { operacaoLogProps } from '../../atoms/Props';

function PayrollLogRow({ log }) {
  return (
    <tr>
      <td>
        <CustomText ellipsis>{log.insercao && log.insercao.format('DD/MM/YYYY HH:mm')}</CustomText>
      </td>
      <td>
        <CustomText ellipsis>{OPERATION_LOG.status[log.tipoOperacao]}</CustomText>
      </td>
      <td>
        <CustomText ellipsis>{log.usuario || ''}</CustomText>
      </td>
      <td>
        <CustomText ellipsis>{log.dataPrevistaFatura && log.dataPrevistaFatura.format('DD/MM/YYYY')}</CustomText>
      </td>
      <td>
        <CustomText ellipsis>{log.faturadoEm && log.faturadoEm.format('DD/MM/YYYY')}</CustomText>
      </td>
      <td>
        <CustomText ellipsis>{log.dataPagamento && log.dataPagamento.format('DD/MM/YYYY')}</CustomText>
      </td>
      <td>
        <CustomText ellipsis>{log.dataProcessamento && log.dataProcessamento.format('DD/MM/YYYY')}</CustomText>
      </td>
      <td>
        <CustomText ellipsis>{moneyFormat(log.valorPortal)}</CustomText>
      </td>
      <td>
        <CustomText ellipsis>{moneyFormat(log.valorLiquidoFolha)}</CustomText>
      </td>
    </tr>
  );
}

PayrollLogRow.propTypes = {
  log: operacaoLogProps,
};

PayrollLogRow.defaultProps = {
  log: {},
};

export default PayrollLogRow;
